// apps/client/src/net/handlers/news.ts (M1-T17) — the board glow and the news list compare mailNewsHead with mailNewsSeen
import type { NetHandlers } from '../../game/game';
import { useGame } from '../../state/store';
export const handlers: NetHandlers = {
  onSnapshot(snap) { useGame.getState().mailSetNewsHead(snap.newsHead); },
  events: { 'news.posted': (e) => { useGame.getState().mailPostNews(e.item); } },
};
